import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17cb2f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "max", "min", "orient", "step", "value"]

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SliderInput',
  props: {
  disabled: Boolean,
  isVertical: Boolean,
  max: {
    type: Number,
    default: 1
  },
  min: {
    type: Number,
    default: 0
  },
  step: {
    type: Number,
    default: 0.01
  },
  value: {
    type: Number,
    default: 0
  },
},
  emits: ['change', 'input'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props

const containerClasses = props.isVertical ? 'vertical-container' : ''
const sliderClasses = props.isVertical ? 'vertical' : ''
const sliderElement = ref(null) // reference to element

const onInput = (event: any) => {
  emit('input', event.target.value)
}
const onChange = (event: any) => {
  emit('change', event.target.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(containerClasses))
  }, [
    _createElementVNode("input", {
      class: _normalizeClass(["slider", _unref(sliderClasses)]),
      ref_key: "sliderElement",
      ref: sliderElement,
      type: "range",
      disabled: __props.disabled,
      max: __props.max,
      min: __props.min,
      orient: __props.isVertical ? 'vertical' : 'horizontal',
      step: __props.step,
      value: __props.value,
      onInput: onInput,
      onChange: onChange
    }, null, 42, _hoisted_1)
  ], 2))
}
}

})